/* unplugin-vue-components disabled */import script from "./selectRemote.vue?vue&type=script&setup=true&lang=js"
export * from "./selectRemote.vue?vue&type=script&setup=true&lang=js"

import "./selectRemote.vue?vue&type=style&index=0&id=fad50108&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad50108"]])

export default __exports__